import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import moment from '../../../../constants/moment';
import {
    toggleModal,
    getAll,
    setValue,
    createNew,
    update,
    deleteEntity,
    tableActions
} from "../../../../../redux/actions/roleActions";
import {
    Button,
    Modal
} from "react-bootstrap";
import {
    TextField,
    FormHelperText,
    Chip,
    Avatar,
    Table,
    TableBody,
    TableHead,
    TableCell,
    TableRow
} from "@material-ui/core";
import DataTable from "../../../../helpers/datatable/DataTable";

import Loading from "../../../../helpers/loading/Loading";
import {
    sortCaret,
    headerSortingClasses,
} from "../../../../../_metronic/_helpers";
import actionsFormatter from "../../../../helpers/datatable/formatters/actionsFormatter";
import { textFilter } from 'react-bootstrap-table2-filter';

function RolesPage(props) {
    useEffect(() => {
        props.getAll(props.auth.user.token);
        return () => {
            // will unMount 
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    const columns = [
        {
            dataField: "roleName",
            text: "Rol Tanımı",
            sort: true,
            filter: textFilter({
                placeholder: "Ara",
                style: {
                    display: props.role.data.length > 0 ? "block" : "none"
                }
            }),
            sortCaret: sortCaret,
            headerSortingClasses
        },
        {
            dataField: "roleCode",
            text: "Rol Kodu",
            sort: true,
            sortCaret: sortCaret,
            filter: textFilter({
                placeholder: "Ara",
                style: {
                    display: props.role.data.length > 0 ? "block" : "none"
                }
            }),
            headerSortingClasses
        },
        {
            dataField: "action",
            text: "",
            
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
            formatter: (cell, row) => {
                return actionsFormatter(cell, row, props.tableActions, props.auth.user.token)
            }

        }
    ];

    return <>
        <Loading show={props.role.isFetchingDetail} />
        <Modal backdrop="static" size="lg" show={props.role.showModal} onHide={() => props.toggleModal(false, "")}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i style={{ marginRight: 5 }} className={props.role.process === "create" ? "fa fa-plus" : props.role.process === "update" ? "fa fa-edit" : "fa fa-trash-alt"}></i>
                    {props.role.process === "create" ? "Yeni Rol" : props.role.process === "update" ? "Rol Düzenle" : "Rol Sil"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.role.process === "create" || props.role.process === "update" ?
                    <div>
                        <TextField
                            label="Rol Adı"
                            
                            style={{ margin: 8 }}
                            placeholder="Rol Adı"
                            autoComplete="off"
                            error={props.role.name_error}
                            value={props.role.name}
                            onChange={(event) => props.setValue("name", event.target.value)}
                            helperText={props.role.name_helpertext}
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            FormHelperTextProps={{
                                style: {
                                    marginLeft: 0
                                }
                            }}
                        />
                        <TextField
                            label="Rol Kodu"
                            
                            style={{ margin: 8 }}
                            placeholder="Rol Kodu"
                            autoComplete="off"
                            error={props.role.code_error}
                            value={props.role.code}
                            onChange={(event) => props.setValue("code", event.target.value)}
                            helperText={props.role.code_helpertext}
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            FormHelperTextProps={{
                                style: {
                                    marginLeft: 0
                                }
                            }}
                        />
                        {
                            props.role.process === "update" && props.role.detail !== null ?
                                <>
                                    <div className="separator separator-dashed my-7"></div>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>ROL DETAYLARI</TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                props.role.detail.createdBy !== null ?
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            <FormHelperText>Oluşturan Kullanıcı / Zamanı</FormHelperText><br />
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            <Chip
                                                                style={{ marginLeft: -5 }}
                                                                avatar={<Avatar>{String(props.role.detail.createdBy.name[0]).toUpperCase() + String(props.role.detail.createdBy.surname[0]).toUpperCase()}</Avatar>}
                                                                label={props.role.detail.createdBy.username}
                                                            /><br />
                                                            <small>{moment(props.role.detail.createdAt).format('DD.MM.YYYY HH:mm:ss')}</small><br />
                                                            <small>{moment(props.role.detail.createdAt).fromNow()}</small>
                                                        </TableCell>
                                                    </TableRow> : null
                                            }

                                            {
                                                props.role.detail.updatedBy !== undefined && props.role.detail.updatedBy !== null ?
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            <FormHelperText>Son Güncelleyen Kullanıcı / Zamanı</FormHelperText>
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            <Chip
                                                                style={{ marginLeft: -5 }}
                                                                avatar={<Avatar>{String(props.role.detail.updatedBy.name[0]).toUpperCase() + String(props.role.detail.updatedBy.surname[0]).toUpperCase()}</Avatar>}
                                                                label={props.role.detail.updatedBy.username}
                                                            /><br />
                                                            <small>{moment(props.role.detail.updatedAt).format('DD.MM.YYYY HH:mm:ss')}</small><br />
                                                            <small>{moment(props.role.detail.updatedAt).fromNow()}</small>
                                                        </TableCell>
                                                    </TableRow> : null
                                            }
                                        </TableBody>
                                    </Table></> : null
                        }
                    </div> :
                    props.table.row !== null && props.table.row.roleName?
                        <>
                            <b>{'"'}{props.table.row.roleName}{'" '}</b> isimli rolü silmek üzeresiniz. İşlemi onaylıyor musunuz?
                  </> : null
                }
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={props.role.isFetchingActions} variant="secondary" onClick={() => props.toggleModal(false, props.role.process)}>
                    İptal
            </Button>
                <Button style={{ minWidth: 50, minHeight: 39, display: "flex", flexDirection: "row", alignItems: "center" }} disabled={props.role.isFetchingActions} onClick={() => {
                    if (props.role.process === "create") {
                        props.createNew(props.auth.user.token,
                            [
                                {
                                    key: "name",
                                    value: props.role.name,
                                    required: true
                                },
                                {
                                    key: "code",
                                    value: props.role.code,
                                    required: true
                                }
                            ])
                    } else if (props.role.process === "update") {
                        props.update(props.auth.user.token, props.table.row.id,
                            [
                                {
                                    key: "name",
                                    value: props.role.name,
                                    required: true
                                },
                                {
                                    key: "code",
                                    value: props.role.code,
                                    required: true
                                }

                            ], props.table.index);
                    } else {
                        props.deleteEntity(props.auth.user.token, props.table.row, props.table.index);
                    }
                }} variant="primary">
                    {
                        props.role.isFetchingActions ?
                            <span className="ml-3 spinner spinner-white"></span> :
                            props.role.process === "delete" ? "Sil" : "Kaydet"
                    }
                </Button>
            </Modal.Footer>
        </Modal>
        <DataTable
            handleModal={props.toggleModal}
            title="Tüm Roller"
            buttonTitle="Yeni Rol"
            cardIcon="fa fa-user-shield"
            buttonIcon="fa fa-plus"
            searchPlaceholder="Ara"
            data={props.role.data}
            columns={columns}
        />
    </>
}

const mapStateToProps = function (state) {
    return {
        auth: state.auth,
        role: state.role,
        table: state.table
    }
}

export default connect(mapStateToProps,
    {
        toggleModal,
        getAll,
        setValue,
        createNew,
        update,
        deleteEntity,
        tableActions,
        
    })(RolesPage);
